import ZenGiftCardsManagerLoyaltyEnabled from './ZenGiftCardsManagerLoyaltyEnabled';

export default ZenGiftCardsManagerLoyaltyEnabled;
